import { apiRecipientGroupAll } from '@/request/api';
import { ref } from 'vue';

export default () => {

    const groupDict = ref([]);

    async function setGroupDict() {
        const { data } = await apiRecipientGroupAll();
        groupDict.value = data || [];
        groupDict.value = groupDict.value.map(first => {
            first.id = first.groupId;
            first.name = first.groupName;
            if (first.recipientList?.length) {
                first.recipientList = first.recipientList.map(second => {
                    second.id = second.id;
                    second.name = second.recipientName;
                    return second;
                })
            }
            return first;
        })
    }

    setGroupDict()

    return { groupDict }
}